import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { firstValueFrom } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class MyAuthService {
  private readonly auth0 = inject(Auth0Service);
  private readonly http = inject(HttpClient);

  private isUserCreated = false;

  /** authentication state */
  readonly isLoggedIn$ = this.auth0.isAuthenticated$;

  /** loading state */
  readonly isLoading$ = this.auth0.isLoading$;

  /** user profile */
  readonly user$ = this.auth0.user$;

  // private _userId = '';

  constructor() {
    this.isLoggedIn$.subscribe(async (loggedIn) => {
      if (loggedIn && !this.isUserCreated) {
        await this.ensureUserExists();
        this.isUserCreated = true;
      }
    });
  }

  async ensureUserExists() {
    try {
      const user = await firstValueFrom(this.user$);
      if (!user) {
        return;
      }

      const payload = {
        auth0Id: user.sub,
        email: user.email,
        name: user.name,
      };

      const res = await firstValueFrom(
        this.http.post<UserDto>('/api/users/create', payload),
      );
      // TODO: we can properly store of this user object if it is needed? that is not clear to me right now.
      // this._userId = res._id;
      console.log('User ensured in DB: ', res);
    } catch (err) {
      console.log('Failed to ensure user exists in DB: ', err);
    }
  }

  // // TODO: we can change how this is done if we want, this is just to get the DB working
  // get userId() {
  //   console.log(this._userId);
  //   if (!this._userId) throw new Error('no user error');
  //   return this._userId;
  // }

  /** login */
  loginWithAuth0(): void {
    this.auth0.loginWithRedirect({
      appState: { target: globalThis.location.pathname },
    });
  }

  /** logout */
  logout(): void {
    this.auth0.logout({
      logoutParams: {
        returnTo: globalThis.location.origin,
      },
    });
  }

  /** access token for API calls if needed manually */
  getAccessToken(audience: string) {
    return this.auth0.getAccessTokenSilently({
      authorizationParams: {
        audience,
      },
    });
  }
}

export interface UserDto {
  _id: string;
  auth0Id: string;
  createdAt: string; // can be convereted to a date outside of dto...
  email: string;
  groups: unknown[];
  name: string;
  updatedAt: string; // can be convereted to a date outside of dto...
}
